import React from "react";

const TermsConditions = () => {
    return (
        <div className="main-container animation-fade-in component-container p-6 flex flex-col">
            {TC_TEXTS.map((item, index) => (
                <React.Fragment key={index}>
                    <h3 className="pl-6 py-6">{item.h3}</h3>
                    {item.text}
                </React.Fragment>
            ))}
        </div>
    );
};
export default TermsConditions;

const TC_TEXTS = [
    {
        h3: "General",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Eligibility",
        text: `Kadido`,
    },
    {
        h3: "Identity verification",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Restrictions",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Termination",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Disclaimers",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Intellectual property",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Independent Parties",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Confidentiality",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Anti-Money Laundering",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Indemnification",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Force Majeure",
        text: (
            <span>
              Kadido
            </span>
        ),
    },
    {
        h3: "Jurisdiction and Governing Law",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Severability",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Notices",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Assignment",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Third Party Rights",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Third Party Website Claimer",
        text: (
            <span>
                Kadido
            </span>
        ),
    },
    {
        h3: "Disclaimer",
        text: (
            <span>
              Kadido
            </span>
        ),
    },
];
